import { DomainError } from './types/DomainError';
export function isDomainError(data) {
    return data instanceof DomainError;
}
export function isDomainData(data) {
    const domains = data.domains;
    if (!domains)
        return false;
    return Array.isArray(domains) &&
        domains.every((el) => typeof el === 'string');
}
//# sourceMappingURL=utils.js.map